<template>
  <div class="about-main">
    <InnerHeader
      :cover="require('../../assets/img/about/cover.jpg')"
      :bgColor="'#164194'"
      :bgPosition="'0 60%'"
      :links="links"
    />
    <About v-if="!$route.query.page"/>
    <History v-else-if="$route.query.page === 'history'"/>
    <Mission v-else-if="$route.query.page === 'mission'"/>
  </div>
</template>

<script>
import InnerHeader from '../shared/InnerHeader';
import About from './About';
import History from './History';
import Mission from './Mission';
export default {
  components: {
    InnerHeader,
    About,
    History,
    Mission
  },
  computed: {
    links() {
      return [
        {
          name: this.$t('nav1-1'),
          url: '/about',
          active: ['/about?scroll=aboutScheme']
        },
        {
          name: this.$t('nav1-2'),
          url: '/about?page=history'
        },
        {
          name: this.$t('nav1-3'),
          url: '/about?page=mission'
        }
      ];
    }
  },
  mounted() {
    document.title = this.$t('title1');
    if (this.$route.query.scroll) {
      setTimeout(() => {
        const targetElement = document.getElementById(this.$route.query.scroll);
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }, 1500);
    }
  },
  destroyed() {
    document.title = this.$t('title0');
  }
};
</script>

<style lang="scss" scoped>
</style>
